/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { threadMetaById } from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';
import getSubagentContextParentId from '@/redux/selectors/pieveSelectors/lib/getSubagentContextParentId.js';
import getSubagentItemsForParentId from '@/redux/selectors/pieveSelectors/lib/getSubagentItemsForParentId.js';
import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { activeThreadParentId } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';

export const mainThreadSubagentContextParentIdForThreadId = (state, threadId) => {
  return getSubagentContextParentId({
    threadMetaByIdValue: threadMetaById(state),
    threadId
  });
};

export const mainThreadSubagentItemsForThreadId = (state, threadId) => {
  return getSubagentItemsForParentId({
    threadMetaByIdValue: threadMetaById(state),
    parentThreadId: mainThreadSubagentContextParentIdForThreadId(state, threadId)
  });
};

export const makeMainThreadSubagentItemsForThreadIdSelector = () =>
  createSelector([threadMetaById, (_, threadId) => getNormalizedThreadId(threadId)], (threadMetaByIdValue, threadId) => {
    return getSubagentItemsForParentId({
      threadMetaByIdValue,
      parentThreadId: getSubagentContextParentId({
        threadMetaByIdValue,
        threadId
      })
    });
  });

export const hasMainThreadSubagentsForThreadId = (state, threadId) => {
  return mainThreadSubagentItemsForThreadId(state, threadId).length > 0;
};

export const mainThreadSubagentContextParentId = createSelector([activeThreadId, activeThreadParentId], (activeThreadIdValue, activeThreadParentIdValue) => {
  const normalizedActiveThreadId = String(activeThreadIdValue || '').trim();

  if (!normalizedActiveThreadId) {
    return null;
  }

  return activeThreadParentIdValue || normalizedActiveThreadId;
});

export const mainThreadSubagentItems = createSelector([threadMetaById, mainThreadSubagentContextParentId], (threadMetaByIdValue, contextParentId) => {
  return getSubagentItemsForParentId({
    threadMetaByIdValue,
    parentThreadId: contextParentId
  });
});

export const hasMainThreadSubagents = createSelector([mainThreadSubagentItems], (items) => items.length > 0);
